
import { defineComponent } from "vue";
import axios from "@/axios-instance";

//thứ tự kỹ năng CỐ ĐỊNH (đồng bộ trang Cài đặt) — dữ liệu lưu lộn xộn, render y nguyên thì mỗi hàng một thứ tự
const SKILLS = [
  { label: "Nghe và đọc", value: "nghe-va-doc" },
  { label: "Viết", value: "viet" },
  { label: "Nói", value: "noi" },
];

export default defineComponent({
  name: "english-exemption-ref-table",
  props: {
    //tên chứng chỉ đang chọn ở form — lọc bảng cho đỡ nhiễu (so lỏng, không khớp thì hiện tất cả)
    certificateName: { type: String, default: "" },
  },
  data() {
    return { all: [] as any[], loading: false };
  },
  computed: {
    filteredMatched(): boolean {
      return this.filterRows().length > 0;
    },
    rows(): any[] {
      const f = this.filterRows();
      const list = f.length ? f : this.all;
      const minOf = (r: any) => {
        const c = (r.activationcriteria || []).filter((i: any) => i.min);
        return c.length ? Math.min(...c.map((i: any) => +i.min || 0)) : Number.MAX_SAFE_INTEGER;
      };
      return [...list].sort((a: any, b: any) => {
        const n = String(a.certificateName || "").localeCompare(String(b.certificateName || ""), "vi");
        return n !== 0 ? n : minOf(a) - minOf(b);
      });
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    filterRows(): any[] {
      const q = String(this.certificateName || "").trim().toLowerCase();
      if (!q) return this.all;
      return this.all.filter((r: any) => {
        const n = String(r.certificateName || "").toLowerCase();
        return n.includes(q) || q.includes(n);
      });
    },
    async load() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/setting/freesubject`);
        this.all = data || [];
      } catch (e) {
        this.all = [];
      }
      this.loading = false;
    },
    criteria(r: any): any[] {
      const list = (r.activationcriteria || []).filter((c: any) => c && (c.min || c.max));
      const idx = (t: any) => { const i = SKILLS.findIndex((s) => s.value === t); return i < 0 ? 99 : i; };
      return [...list].sort((a: any, b: any) => idx(a.type) - idx(b.type));
    },
    skillLabel(t: any): string {
      return SKILLS.find((s) => s.value === t)?.label || t;
    },
    //bậc CAO NHẤT = miễn học hoàn toàn (không còn học phần nào phải học tiếp)
    isFullExempt(r: any): boolean {
      return !(r.nextlevel || []).some((i: any) => String(i.code || "").trim());
    },
    //Ngưỡng lưu dạng NỬA MỞ: min <= điểm < max. In "min – max" khiến 2 bậc liền nhau trông như chồng
    //biên (4.0–4.5 rồi 4.5–5.5). Bậc miễn hoàn toàn thì max chỉ là TRẦN THANG ĐIỂM (9.0 / 990 / 170…)
    //chứ không phải điều kiện -> in "≥ min" cho khớp cách viết trong quy định.
    bandText(r: any, c: any): string {
      const min = String(c.min ?? "").trim();
      const max = String(c.max ?? "").trim();
      if (!min) return max ? `dưới ${max}` : "—";
      if (!max || this.isFullExempt(r)) return `≥ ${min}`;
      return `${min} – dưới ${max}`;
    },
    nextLevelText(r: any): string {
      return (r.nextlevel || []).filter((i: any) => i.code).map((i: any) => i.name || i.code).join(", ");
    },
  },
});
